import http from '@/api/http'

export default {
    getTokenList(cb, request) {
        http.post('/api/token/list', cb, request)
    },
    getTokenListByOwner(cb) {
        http.get('/api/token/list/owner', cb, {})
    },
    getTokenById(cb, id) {
        http.get('/api/token/get', cb, { "id": id })
    },
    getCategories(cb) {
        http.get('/api/categories/list', cb, {})
    },
    getCurrencyLists(cb) {
        http.get('/api/price/getCurrencyList', cb, {})
    },
    getSortByList(cb) {
        http.get('/api/sortBy/list', cb, {})
    },
    saveToken(cb, request) {
        http.post('/api/token/save', cb, request)
    },
    saveListing(cb, request) {
        http.post('/api/price/addSetPriceInfo', cb, request)
    },
    saveHighestbid(cb, request) {
        http.post('/api/price/addHighestBidInfo', cb, request)
    },
    changesell(cb, request) {
        http.post('/api/price/cancelListing', cb, request)
    },
    getNFTasset(cb, request) {
        http.post('/api/price/getListingAndOffer', cb, request)
    },
    postMakeoffer(cb, request) {
        http.post('/api/price/makeOffer', cb, request)
    },
    buyNow(cb, request) {
        http.post('/api/price/buyNow', cb, request)
    },
    changebutton(cb, request) {
        http.post('/api/button/control', cb, request)
    },
    changeCancel(cb, request) {
        http.post('/api/price/cancelOffer', cb, request)
    },
    changeAccept(cb, request) {
        http.post('/api/price/acceptOffer', cb, request)
    },
    getAccountList(cb) {
        http.get('/api/account/list', cb, {})
    },
}